import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const FilterControls = ({
  sortBy,
  onSortChange,
  filterScore,
  onFilterChange,
  searchQuery,
  onSearchChange
}) => {
  const sortOptions = [
    { value: 'date', label: 'Latest First', icon: 'Calendar' },
    { value: 'score', label: 'Highest Score', icon: 'TrendingUp' },
    { value: 'photos', label: 'Most Photos', icon: 'Image' }
  ];

  const filterOptions = [
    { value: 'all', label: 'All Scores' },
    { value: 'high', label: 'High (8+)' },
    { value: 'medium', label: 'Medium (6-8)' },
    { value: 'low', label: 'Low (<6)' }
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-5 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Icon name="Filter" size={18} color="var(--color-primary)" />
          <span className="text-sm font-semibold text-foreground">Filters</span>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 flex-1">
          <div className="flex-1">
            <label className="text-xs text-muted-foreground caption mb-1.5 block">
              Sort By
            </label>
            <div className="flex gap-2">
              {sortOptions?.map((option) => (
                <button
                  key={option?.value}
                  onClick={() => onSortChange(option?.value)}
                  className={cn(
                    'flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-smooth flex-1 sm:flex-initial',
                    sortBy === option?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted/30 text-foreground hover:bg-muted/50'
                  )}
                >
                  <Icon
                    name={option?.icon}
                    size={14}
                    color={sortBy === option?.value ? 'currentColor' : 'var(--color-muted-foreground)'}
                  />
                  <span className="hidden sm:inline">{option?.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="flex-1">
            <label className="text-xs text-muted-foreground caption mb-1.5 block">
              Score Range
            </label>
            <div className="flex gap-2">
              {filterOptions?.map((option) => (
                <button
                  key={option?.value}
                  onClick={() => onFilterChange(option?.value)}
                  className={cn(
                    'px-3 py-2 rounded-lg text-sm font-medium transition-smooth flex-1 sm:flex-initial',
                    filterScore === option?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted/30 text-foreground hover:bg-muted/50'
                  )}
                >
                  {option?.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;